export default "__VITE_ASSET__fe518365__"